<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Page non trouvée - 404</title>
    <!-- Bootstrap 5 CSS -->
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
    <!-- Google Fonts -->
    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">

</head>
<body>
    <div class="error-container">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 class="error-code">404</h1>
                    <h2 class="error-title">Page non trouvée</h2>
                    <p class="error-message">
                        Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
                        Vous pouvez retourner à la page d'accueil .
                    </p>

                </div>
                >
            </div>
        </div>
    </div>

    <!-- Bootstrap 5 JS avec Popper -->
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>
